import { render, staticRenderFns } from "./RPDeviceSuppliersByDeal.vue?vue&type=template&id=1658ada1&scoped=true"
import script from "./RPDeviceSuppliersByDeal.vue?vue&type=script&lang=js"
export * from "./RPDeviceSuppliersByDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1658ada1",
  null
  
)

export default component.exports